import { DI } from '@intigral/constant/config/DIContainer';
import { container } from '../../../DataDomain';
import { IDiscountRepository } from '../../repositories/interfaces/iDiscountRepository';
import { CSRFTokenRequest } from '../../../entity';
import { IValidateGiftCardResponseData } from '../../../entity/interface/iDiscounts';
import { AxiosError } from 'axios';

export interface IValidateGiftCardUseCase {
    execute(
        card_number: string,
        event_type: string,
        csrfToken: CSRFTokenRequest
    ): Promise<IValidateGiftCardResponseData>;
}

export class ValidateGiftCardUseCase implements IValidateGiftCardUseCase {
    // Lazy getter for repository to avoid circular dependencies
    private get validateGiftCard(): IDiscountRepository {
        return container.resolve<IDiscountRepository>(DI.REPOSITORIES.IDiscountRepository);
    }
    constructor() {
        // No initialization needed - dependencies resolved lazily via getters
    }
    async execute(
        card_number: string,
        event_type: string,
        csrfToken: CSRFTokenRequest
    ): Promise<IValidateGiftCardResponseData> {
        const response = await this.validateGiftCard.validateGiftCard(card_number, event_type, csrfToken);
        if (response.data) {
            return response.data;
        }
        throw new AxiosError('Invalid response from API', '500');
    }
}
